module.exports = __webpack_public_path__ + "static/media/backimage.43f724bf.jpg";